import * as React from 'react';

import {OnboardingBody} from 'shells/onboarding-page/onboarding-body';

export function Introduction() {
    return (
        <OnboardingBody title='Learn where leads come from with Nutshell Analytics'>
            <p>
                Knowing where your leads come from can help your team make the right sales and
                marketing decisions.
            </p>
            <p>
                It can be challenging to connect the dots between someone searching for your
                business on Google, clicking an ad, landing on your website, and eventually filling
                out a contact form.
            </p>
            <p>
                <strong>Nutshell Analytics</strong> makes this a lot easier.
            </p>
        </OnboardingBody>
    );
}
